import React from 'react';
import { Provider } from 'mobx-react';
// import { configure } from 'mobx';

import storeList from './store';
import Routes from './routes/Routes';
import Auth from './components/auth';

import './pages/share/css/share-code.css';

/**
 * Mobx开启严格模式
 */
// configure({
//   enforceActions: 'observed',
// });

const needJudgePages = ['/confirmorder', 'pay', '/productDetail', '/myReward'];

function App() {
  return (
    <Provider {...storeList}>
      <Auth needJudgePages={needJudgePages}>
        <Routes />
      </Auth>
    </Provider>
  );
}

export default App;
